import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const PageFilters = ({ filters, onFilterChange, onSearch, searchQuery }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'archived', label: 'Archived' }
  ];

  const authorOptions = [
    { value: 'all', label: 'All Authors' },
    { value: 'sarah', label: 'Sarah Mitchell' },
    { value: 'john', label: 'John Anderson' },
    { value: 'emily', label: 'Emily Chen' },
    { value: 'michael', label: 'Michael Rodriguez' }
  ];

  const sortOptions = [
    { value: 'modified', label: 'Last Modified' },
    { value: 'title', label: 'Title (A-Z)' },
    { value: 'views', label: 'Most Viewed' },
    { value: 'seo', label: 'SEO Score' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Icon
              name="Search"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <Input
              type="search"
              placeholder="Search pages by title, URL, or content..."
              value={searchQuery}
              onChange={(e) => onSearch(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 lg:w-auto">
          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
            placeholder="Status"
          />

          <Select
            options={authorOptions}
            value={filters?.author}
            onChange={(value) => onFilterChange('author', value)}
            placeholder="Author"
          />

          <Select
            options={sortOptions}
            value={filters?.sort}
            onChange={(value) => onFilterChange('sort', value)}
            placeholder="Sort by"
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-4">
        <span className="text-sm text-muted-foreground">Quick filters:</span>
        <button
          onClick={() => onFilterChange('status', 'published')}
          className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success hover:bg-success/20 transition-colors"
        >
          Published
        </button>
        <button
          onClick={() => onFilterChange('status', 'draft')}
          className="px-3 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground hover:bg-muted/80 transition-colors"
        >
          Drafts
        </button>
        <button
          onClick={() => onFilterChange('status', 'scheduled')}
          className="px-3 py-1 rounded-full text-xs font-medium bg-warning/10 text-warning hover:bg-warning/20 transition-colors"
        >
          Scheduled
        </button>
      </div>
    </div>
  );
};

export default PageFilters;